import { i18n } from '@/config/i18n'

interface BilingualLabel {
  labelES?: string
  labelEN?: string
  label?: string
}

export function resolveFieldLabel(field: BilingualLabel): string {
  const locale = i18n.global.locale.value
  if (locale === 'en' && field.labelEN) return field.labelEN
  if (field.labelES) return field.labelES
  return field.label || ''
}

export function enrichFieldWithLabel<T extends BilingualLabel>(field: T): T {
  return { ...field, label: resolveFieldLabel(field) }
}

// Rótulos que cambian según el país de la compañía (Companies/{id}.country).
// Solo cambia el texto visible: la key y el dato del campo son los mismos.
const COUNTRY_LABEL_OVERRIDES: Record<string, Record<string, string>> = {
  MX: { agente_de_aduana: 'fieldsManagement.countryLabels.customsOffice' }
}

export function getFieldDisplayLabel(
  field: BilingualLabel & { name?: string },
  country?: string | null
): string {
  const key = country && field.name ? COUNTRY_LABEL_OVERRIDES[country]?.[field.name] : undefined
  return key ? i18n.global.t(key) : resolveFieldLabel(field)
}
